export const UTILITY_MUTATIONS = Object.freeze({
    SET_UPTIME: "SET_UPTIME",
    UNSET_UPTIME: "UNSET_UPTIME",
    SET_VALUE: "SET_VALUE",
});
